<div id="app-toolbar">
    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-services"
        label=""
        #navBtnServices
        (click)="servicesMenu.toggle($event)">
        <span class="screen-lg"> {{ 'toolbar.services' | translate }} <i class="fa-regular fa-angle-down"></i> </span>
        <span class="screen-sm">YX</span>
    </button>
    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-support"
        #navBtnSupport
        (click)="supportMenu.toggle($event)">
        <span class="screen-lg"> {{ 'toolbar.support' | translate }} <i class="fa-regular fa-angle-down"></i> </span>
        <span class="screen-sm"><i class="fa-light fa-circle-question"></i></span>
    </button>

    <!-- todo after mvp -->
    <!-- <a [href]="quickorderMessagesUrl" target="_blank" class="nav-link" id="nav-btn-notifications-container">
  <button
    pButton
    type="button"
    class="p-button-secondary p-button-text nav-btn"
    id="nav-btn-notifications"
    tabindex="-1"
    aria-label="Notifications button">
    <i class="fa-light fa-bell"></i>
  </button>
</a> -->

    <button
        id="nav-btn-cart"
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        tabindex="-1"
        aria-label="Cart button"
        (click)="hideMenuCart ? null : cartOrdersMenu.toggle($event)">
        <i
            pBadge
            [value]="cartOrdersNumber"
            [class.hide-badge]="cartOrdersNumber === '0'"
            severity="danger"
            class="fa-light fa-cart-shopping">
        </i>
    </button>

    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-user"
        #navBtnUser
        (click)="profileMenu.toggle($event)">
        <span
            style="
                min-height: 31px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                gap: 2px;
                max-width: 200px;
            ">
            <app-ellipsis-tooltip [paragraphId]="'nav-current-user-name'" [disableTooltip]="true">{{
                currentUser?.shortName
            }}</app-ellipsis-tooltip>
            @if (currentUser?.role === roles.ADMIN) {
                <p id="nav-current-user-role">ADMIN</p>
            }
        </span>
        <span id="user-avatar-container">
            <app-user-avatar></app-user-avatar>
        </span>
    </button>
</div>

<p-overlayPanel
    #servicesMenu
    styleClass="action-item-menu fixed-position top-nav-overlay"
    [ariaLabel]="'toolbar.services.ariaLabel' | translate"
    [focusOnShow]="true">
    <app-menu-services
        #servicesMenu
        (closePopover)="servicesMenu.toggle(false); navBtnServices.focus()"></app-menu-services>
</p-overlayPanel>

<p-overlayPanel
    #supportMenu
    styleClass="action-item-menu fixed-position top-nav-overlay"
    [ariaLabel]="'toolbar.support.ariaLabel' | translate"
    [focusOnShow]="true">
    <app-menu-support (closePopover)="supportMenu.toggle(false); navBtnSupport.focus()"></app-menu-support>
</p-overlayPanel>

<p-overlayPanel
    #profileMenu
    [styleClass]="
        'action-item-menu fixed-position top-nav-overlay' + (isSwitchGroupDisplayed ? ' switch-group-overlay' : '')
    "
    [ariaLabel]="'toolbar.profileMenu.ariaLabel' | translate"
    [focusOnShow]="true"
    (onHide)="isSwitchGroupDisplayed = false">
    <app-menu-profile
        [isSwitchGroupDisplayed]="isSwitchGroupDisplayed"
        (switchGroupDisplayChange)="isSwitchGroupDisplayed = $event"
        (closePopover)="
            profileMenu.toggle(false); navBtnUser.focus(); isSwitchGroupDisplayed = false
        "></app-menu-profile>
</p-overlayPanel>

<p-overlayPanel
    #cartOrdersMenu
    [ariaLabel]="'toolbar.cartOrdersMenu.ariaLabel' | translate"
    styleClass="action-item-menu fixed-position top-nav-overlay"
    [focusOnShow]="true">
    @if (window.innerWidth > 990) {
        <app-menu-cart-orders></app-menu-cart-orders>
    }
</p-overlayPanel>
